import { Box, useDisclosure, Flex } from "@chakra-ui/react";
import ActivityDrawer from "./ActivityDrawer";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useNavigate } from "react-router-dom";
import MyInfo from "./MyInfo";
import Activity from "./Activity";
import SetDrawer from "./SetDrawer";
import { getOrdersByRecipient, Order, Status } from "@/api/order";
import { useUserInfo } from "@/context/UserInfo";
import PaymentMethod from "./PaymentMethod";
import CurrencySwitch from "@/components/CurrencySwitch";

dayjs.extend(relativeTime);

const Merchant = () => {
  const { senderAddress } = useUserInfo();
  const { showUsd, handleSwitchCurrency, showBalance, handleShowBalance } =
    useUserInfo();

  const [activityList, setActivityList] = useState<Order[]>([]);

  const {
    isOpen: isActivityDrawerOpen,
    onOpen: onActivityDrawerOpen,
    onClose: onActivityDrawerClose,
  } = useDisclosure();

  const {
    isOpen: isSetDrawerOpen,
    onOpen: onSetDrawerOpen,
    onClose: onSetDrawerClose,
  } = useDisclosure();

  const getActivityList = async () => {
    const response = await getOrdersByRecipient({
      recipient: senderAddress,
      status: Status.Completed,
    });
    setActivityList(response);
  };

  useEffect(() => {
    if (!senderAddress) {
      return;
    }

    getActivityList();
    const timer = setInterval(() => {
      getActivityList();
    }, 3000);
    return () => {
      clearInterval(timer);
    };
  }, [senderAddress]);

  return (
    <Box
      sx={{
        padding: "20px",
        height: "100%",
      }}
    >
      <MyInfo
        onOpen={onSetDrawerOpen}
        showBalance={showBalance}
        onChangeBalance={(show) => {
          handleShowBalance(show);
        }}
      ></MyInfo>
      <PaymentMethod></PaymentMethod>
      <Flex
        sx={{
          width: "100%",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <CurrencySwitch
          onChange={handleSwitchCurrency}
          checked={showUsd}
        ></CurrencySwitch>
      </Flex>

      <Activity list={activityList} showBalance={showBalance}></Activity>

      <ActivityDrawer
        isOpen={isActivityDrawerOpen}
        onClose={onActivityDrawerClose}
      ></ActivityDrawer>
      <SetDrawer
        isOpen={isSetDrawerOpen}
        onClose={onSetDrawerClose}
      ></SetDrawer>
    </Box>
  );
};

export default Merchant;
